var PalantirContentModule = /** @class */ (function () {
    function PalantirContentModule() {
    }
    return PalantirContentModule;
}());
export { PalantirContentModule };
